<template>
  <tab-layout :full-width="true">
    <form slot="tabContent" novalidate @submit.prevent="handleSubmit">
      <div class="bg-white rounded mb-4 p-3">
        <page-heading>ACA Terms &amp; Conditions</page-heading>

        <form-alert :message="alert.message.value" :type="alert.type.value" />

        <div v-if="!loading" class="f-form mb-3">
          <div class="f-form__full">
            <label class="default-form__label font-weight-bold">Text</label>
            <vue-editor v-model="pageText" />
          </div>
        </div>

        <app-button type="submit" :block="false" :loading="saving || loading">
          Save
        </app-button>
      </div>
    </form>
  </tab-layout>
</template>

<script>
import { defineComponent, onMounted } from '@vue/composition-api'
import { VueEditor } from 'vue2-editor'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import FormAlert from '@/components/FormAlert'
import AppButton from '@/components/AppButton'
import useTermsPage from '@/composables/pages/useTermsPage'

export default defineComponent({
  name: 'TermsAndConditions',
  components: { TabLayout, PageHeading, FormAlert, AppButton, VueEditor },
  setup() {
    const { pageText, title, loading, saving, alert, fetchPage, savePage } = useTermsPage()

    async function handleSubmit() {
      await savePage()
    }

    onMounted(() => {
      fetchPage()
    })

    return { pageText, title, loading, saving, alert, handleSubmit }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Pages/TermsAndConditions/TermsAndConditions.vue